module.exports = __webpack_public_path__ + "static/img/t45.bf106266.png";